import { render, staticRenderFns, recyclableRender, components } from "./s-popup.vue?vue&type=template&id=311cbeca&scoped=true&"
var renderjs
import script from "./s-popup.vue?vue&type=script&lang=js&"
export * from "./s-popup.vue?vue&type=script&lang=js&"
import style0 from "./s-popup.vue?vue&type=style&index=0&id=311cbeca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311cbeca",
  null,
  false,
  components,
  renderjs
)

export default component.exports